"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ManageWorkspace = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var avatar_1 = __importDefault(require("@atlaskit/avatar"));
var button_1 = __importDefault(require("@atlaskit/button"));
var contexts_1 = require("../../contexts");
var ManageWorkspace = function (_a) {
    var _b;
    var numberOfWorkspaceMembers = _a.numberOfWorkspaceMembers;
    var _c = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), me = _c.me, trelloIframe = _c.trelloIframe, org = _c.org, members = _c.members;
    var _d = (0, react_1.useContext)(contexts_1.PaymentsContext), subscription = _d.subscription, cancelSubscription = _d.cancelSubscription, refetchSubscription = _d.refetchSubscription, makePortalSession = _d.makePortalSession;
    var meIsPayer = me.id === subscription.idMemberPayer;
    var payer = members.find(function (m) { return m.id === subscription.idMemberPayer; });
    var hasLegacySubscription = subscription.hasLegacyWorkspaceSubscription;
    var hasV2WorkspaceSubscription = subscription.hasV2WorkspaceSubscription;
    var hasV3WorkspaceSubscription = subscription.hasV3WorkspaceSubscription;
    var isV3Subscription = subscription.v3; // this means multi-workspace
    var meIsExcludedFromV3Subscription = subscription.v3 && !((_b = subscription.idMembers) === null || _b === void 0 ? void 0 : _b.includes(me.id));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    borderRadius: '4px',
                    backgroundColor: '#fff280',
                    padding: '8px',
                    textAlign: 'center',
                    fontWeight: 500,
                    marginBottom: '16px',
                    color: 'black'
                } }, { children: trelloIframe.localizeKey('the-workspace-has-a-license', {
                    workspaceName: org.name
                }) }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    textAlign: 'center',
                    marginBottom: '16px'
                } }, { children: trelloIframe.localizeKey('total-for-n-members', {
                    workspaceMembersCount: numberOfWorkspaceMembers
                }) }), void 0), (0, jsx_runtime_1.jsxs)("h1", __assign({ style: {
                    textAlign: 'center',
                    fontSize: '24px',
                    lineHeight: '24px',
                    margin: '8px 0',
                    marginBottom: '16px'
                } }, { children: [trelloIframe.localizeKey('$n-per-month', {
                        workspaceMembersCount: numberOfWorkspaceMembers *
                            (hasLegacySubscription
                                ? 1
                                : hasV2WorkspaceSubscription
                                    ? 3
                                    : hasV3WorkspaceSubscription
                                        ? 5
                                        : 9.99)
                    }), ' ', "(usd)"] }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    textAlign: 'center',
                    marginBottom: '16px'
                } }, { children: trelloIframe.localizeKey(hasLegacySubscription
                    ? 'priced-at-$1-per-user-per-month'
                    : hasV2WorkspaceSubscription
                        ? 'priced-at-$3-per-user-per-month'
                        : hasV3WorkspaceSubscription
                            ? 'priced-at-$5-per-user-per-month'
                            : 'priced-at-$9.99-per-user-per-month') }), void 0), payer && ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginTop: '12px'
                } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: trelloIframe.localizeKey('this-workspace-license-is-managed-by') }, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                            padding: '8px 0',
                            textAlign: 'center'
                        } }, { children: [(0, jsx_runtime_1.jsx)(avatar_1["default"], { src: payer.avatar, size: "xsmall" }, void 0), " ", (0, jsx_runtime_1.jsx)("b", { children: payer.fullName }, void 0)] }), void 0)] }), void 0)), (hasLegacySubscription ||
                hasV2WorkspaceSubscription ||
                hasV3WorkspaceSubscription) && ((0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: '16px' } }, { children: trelloIframe.localizeKey('If you cancel this license, you will have to pay the new price.') }), void 0)), meIsPayer && isV3Subscription && ((0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: '16px' } }, { children: (0, jsx_runtime_1.jsx)(button_1["default"], __assign({ appearance: "link", target: "_blank", href: "https://tinypowerups.com/manage-subscription#workspaces" }, { children: trelloIframe.localizeKey('This workspace is a part of an Advanced Billing Subscription.') }), void 0) }), void 0)), meIsExcludedFromV3Subscription && ((0, jsx_runtime_1.jsx)("div", { children: meIsPayer
                    ? trelloIframe.localizeKey('Your user was not incldued in the Advanced Billing Subscription.')
                    : trelloIframe.localizeKey('Your user was not incldued in the Advanced Billing Subscription. Please ask your admin to add you.') }, void 0)), meIsPayer && ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ shouldFitContainer: true, onClick: function () {
                    makePortalSession()
                        .then(function (session) {
                        window.open(session.url, '_blank');
                    })["catch"](function (error) {
                        trelloIframe.alert({
                            message: 'Something went wrong. Please try again or contact support.'
                        });
                    });
                } }, { children: trelloIframe.localizeKey('manage-subscription') }), void 0)), meIsPayer && !isV3Subscription && ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ appearance: "subtle", shouldFitContainer: true, onClick: function (e) {
                    trelloIframe.popup({
                        mouseEvent: e,
                        type: 'confirm',
                        title: trelloIframe.localizeKey('cancel-membership'),
                        message: trelloIframe.localizeKey('are-you-sure-you-want-to-cancel-workspace-license'),
                        confirmText: 'Yes',
                        confirmStyle: 'danger',
                        onConfirm: function (t_onConfirm) { return __awaiter(void 0, void 0, void 0, function () {
                            var e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, cancelSubscription('workspace', org.id)];
                                    case 1:
                                        _a.sent();
                                        t_onConfirm.popup({
                                            type: 'confirm',
                                            title: trelloIframe.localizeKey('cancel-membership'),
                                            message: trelloIframe.localizeKey('your-workspace-license-has-been-cancelled'),
                                            confirmText: trelloIframe.localizeKey('ok'),
                                            onConfirm: function (x) {
                                                x.closePopup();
                                                refetchSubscription();
                                            }
                                        });
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_1 = _a.sent();
                                        t_onConfirm.popup({
                                            type: 'confirm',
                                            title: trelloIframe.localizeKey('something-went-wrong'),
                                            message: trelloIframe.localizeKey('we-could-not-cancel-your-membership'),
                                            confirmText: trelloIframe.localizeKey('ok'),
                                            onConfirm: function (x) {
                                                x.closePopup();
                                            }
                                        });
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                } }, { children: trelloIframe.localizeKey('cancel-license') }), void 0))] }, void 0));
};
exports.ManageWorkspace = ManageWorkspace;
//# sourceMappingURL=ManageWorkspace.js.map